// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale/:slug*\",\"regex\":\"^/([^/]+)/(.+)$\",\"paramNames\":[\"locale\",\"slug\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/faq/:slug*\",\"regex\":\"^/([^/]+)/faq/(.+)$\",\"paramNames\":[\"locale\",\"slug\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/search\",\"regex\":\"^/([^/]+)/search$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/sidepanel/:slug*\",\"regex\":\"^/([^/]+)/sidepanel/(.+)$\",\"paramNames\":[\"locale\",\"slug\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/support/:slug*?\",\"regex\":\"^/([^/]+)/support(?:/(.*))?$\",\"paramNames\":[\"locale\",\"slug\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/preview/:slug*\",\"regex\":\"^/([^/]+)/preview/(.+)$\",\"paramNames\":[\"locale\",\"slug\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/preview/support/:slug*?\",\"regex\":\"^/([^/]+)/preview/support(?:/(.*))?$\",\"paramNames\":[\"locale\",\"slug\"],\"hasOptionalPrefix\":true},{\"path\":\"/payload/admin/:segments*?\",\"regex\":\"^/payload/admin(?:/(.*))?$\",\"paramNames\":[\"segments\"],\"hasOptionalPrefix\":false},{\"path\":\"/payload/live-preview/:locale/app-banners/:id\",\"regex\":\"^/payload/live-preview/([^/]+)/app-banners/([^/]+)$\",\"paramNames\":[\"locale\",\"id\"],\"hasOptionalPrefix\":true},{\"path\":\"/payload/live-preview/:locale/pull-notifications/:id\",\"regex\":\"^/payload/live-preview/([^/]+)/pull-notifications/([^/]+)$\",\"paramNames\":[\"locale\",\"id\"],\"hasOptionalPrefix\":true},{\"path\":\"/payload/segmentables/:contentType/:externalId\",\"regex\":\"^/payload/segmentables/([^/]+)/([^/]+)$\",\"paramNames\":[\"contentType\",\"externalId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.6";import * as Sentry from '@sentry/nextjs';
import { filterTranslationHydrationError } from './sentry.client-filters';

// The runtime image is built in compile mode, which does not inline NEXT_PUBLIC_*
// into client bundles, so the config is read from window.__SENTRY_CONFIG__ —
// injected synchronously by SentryClientConfig before this hook runs.
const config = window.__SENTRY_CONFIG__;

if (config) {
	Sentry.init({
		dsn: config.dsn,
		environment: config.environment,
		release: config.release,

		// Adds request headers and IP for users
		sendDefaultPii: true,

		enableLogs: true,

		// Add optional integrations for additional features
		integrations: [],

		// Browser translation mutates the DOM before React hydrates, producing a
		// non-actionable hydration mismatch. Drop those events while keeping real
		// hydration errors visible in Sentry.
		beforeSend(event) {
			return filterTranslationHydrationError(event);
		},

		// Drop noise originating from browser extensions — not our code. (sessionStorage privacy
		// errors are handled at the source via safeSessionStorage, so they are not filtered here.)
		ignoreErrors: [
			// Firefox reader-mode extension
			/__firefox__/,
			// Domain/price-comparison browser extension
			"undefined is not an object (evaluating 't.Domain')",
			"undefined is not an object (evaluating 'i.DomainData')",
			/Cannot read properties of undefined \(reading 'Domain(?:Data)?'\)/,
			// Ad-blocker preventing the Sentry SDK from loading correctly
			/new .*\.InboundFilters/,
			// JSON response rewritten by an extension/proxy
			/jsonFeed/,
		],

		// Drop errors thrown from browser-extension contexts.
		denyUrls: [/extensions\//i, /^chrome:\/\//i, /^moz-extension:\/\//i, /^safari-extension:\/\//i],

		// Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
		tracesSampleRate: 0.1,

		// Define how likely Replay events are sampled.
		// This sets the sample rate to be 10%. You may want this to be 100% while
		// in development and sample at a lower rate in production
		replaysSessionSampleRate: 0.1,

		// Define how likely Replay events are sampled when an error occurs.
		replaysOnErrorSampleRate: 1.0,

		// Setting this option to true will print useful information to the console while you're setting up Sentry.
		debug: false,
	});

	import('@sentry/nextjs').then((lazyLoadedSentry) => {
		Sentry.addIntegration(
			lazyLoadedSentry.replayIntegration({
				maskAllText: false,
				blockAllMedia: false,
			}),
		);
	});
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
